export enum ModerationStatus {
  CANCEL = 'cancel',
  WAIT = 'wait',
  DONE = 'done',
  CONFIRM = 'confirm',
  MODERATION = 'moderation',
  HOLD = 'hold',
}
